<template>
  <van-dialog
    v-model="show"
    :show-cancel-button="true"
    title="请补全序列号"
    :beforeClose="beforeClose"
  >
    <div class="field-wrapper">
      <span>
        {{ snPrefix }}
      </span>
      <van-field
        v-model="snSuffix"
        :placeholder="'后四位'"
        :maxlength="4"
        :border="true"
      />
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      show: false,
      code: '',
      snPrefix: '',
      snSuffixLength: 4,
      snSuffix: ''
    }
  },
  methods: {
    reset() {
      this.code = ''
      this.snPrefix = ''
      this.snSuffix = ''
    },
    open(data) {
      this.reset()
      const {
        snPrefix,
        code
      } = data

      this.code = code
      this.snPrefix = snPrefix
      this.show = true
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        if (!this.snSuffix || this.snSuffix.length !== this.snSuffixLength) {
          this.$Toast.fail(`请补全序列号后${this.snSuffixLength}位`)
          done(false)
        } else {
          this.confirm()
          done()
        }
      } else {
        done()
      }
    },
    confirm() {
      this.$emit('confirm', { code: this.code, number: `${this.snPrefix}${this.snSuffix}` })
    }
  }
}
</script>

<style lang="less" scoped>
  .field-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .van-field {
      width: 240px;
      padding-left: 4px;
      /deep/ input {
        font-weight: bold;
        font-size: 50px;
        color: @primary-color-2;
        &::placeholder {
          font-size: 50px;
        }
      }
    }
  }
</style>